import { isFeatureEnabled } from 'owa-feature-flags';
import { ClientItem, mailStore } from 'owa-mail-store';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { lazyIsSmimeItemDecoding } from 'owa-smime';
import showActionBlockedDialog from 'owa-smime/lib/utils/showActionBlockedDialog';

/**
 * Util to decide whether we allow response for S/MIME item or not
 * in message view.
 * Response for S/MIME item is not allowed when
 * 1. S/MIME is in decoding state.
 * 2. 'cmp-smime' feature flag is off.
 */
const allowResponseForSmimeItem = async (
    itemId: string,
    itemActionString: string
): Promise<boolean> => {
    if (isConsumer()) {
        return true;
    }

    const item: ClientItem = mailStore.items.get(itemId);

    if (!isFeatureEnabled('rp-smime') || !isFeatureEnabled('cmp-smime')) {
        // Block response when item is S/MIME and feature flag is disabled.
        showActionBlockedDialog(itemActionString);
        return false;
    }

    const isSmimeDecoding = await (await lazyIsSmimeItemDecoding.import())(item);

    if (isSmimeDecoding) {
        showActionBlockedDialog(itemActionString);
    }

    return !isSmimeDecoding;
};

export default allowResponseForSmimeItem;
